import { useRouter } from 'next/router';
import useSWR from 'swr';
import { customSWRConfig, customSWRResponse, PaginatedData, Ticket } from '../../model/types';
import { isValidNumberForRequest } from '../../utils/validation';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useAssociableTickets(
    userId: number,
    config: customSWRConfig = {}
): customSWRResponse<Ticket[]> {
    const {
        query: { ticketKey }
    } = useRouter();

    const keys = useSWRCacheKeys(isValidNumberForRequest(userId) ? `/tickets/for-merge?userId=${userId}` : null);

    const { data, isLoading, isValidating } = useSWR<PaginatedData<Ticket>>(keys, { ...config });

    const filteredTicketList = data?.content?.filter((ticket) => ticket.key !== ticketKey);

    return {
        data: filteredTicketList,
        isLoading: isLoading && isValidating
    };
}
